import { ethers } from 'ethers';
import { getToken } from '@/utils/auth'
import Contract from 'web3-eth-contract'
import ERC20 from './ERC20.json'
import ShanHaiJing from './ShanHaiJing.json'
import FlowMiner from './FlowMiner.json' 
import CommunityIncentive from './CommunityIncentive.json' 
import BUR from './BUR.json' //main 
import Vue from 'vue'
import abierc from './abierc.json' //查代币
import TokenStaking from './TokenStaking.json' //TokenStaking
import LPStaking from './LPStaking.json' //LPStaking 
// import Invitation from './Invitation.json' //Invitation
import Web3 from 'web3'
// let ShanHaiJingTokenAddress = "0x72438dFa10681f298b21E69CCe026B7aE50D34E7"; //测试ShanHaiJing
// let FlowMinerTokenAddress = "0x9B28048BDf45713D7F69756A14FFe0c029B5DA90"; //测试FlowMiner
// let CommunityIncentiveTokenAddress = "0x5991816E53971BE8345AC369B9A60Eaf69D4E888"; //测试CommunityIncentive
// let FlowToken="0x92b3576E4E6079600F7bb4302702814ac3F55a86" //Flow测试代币地址
// let TokenStakingTokenAddress = "0x72dfd7ee5eb4c0869377fe0ea653fa1ff3daf632"; //TokenStaking测试
// let LPStakingTokenAddress = "0x30e28b5cb7c17f0832897b23065583eefd0eb0b5"; //LPStaking测试 
// let InvitationTokenAddress = "0xfe31031e9987be72a569be592b30ab4030b0a29f"; //Invitation 测试 
// let web3 = new Web3(new Web3.providers.HttpProvider('https://data-seed-prebsc-1-s1.binance.org:8545/'))//币安的节点
// Contract.setProvider('https://data-seed-prebsc-1-s1.binance.org:8545/')//币安的节点
// let FlowToken="0xba7fc05ef28b6c332daa2152495c14d03276417f" //Flo正式代币地址
// let ShanHaiJingTokenAddress = "0x72438dFa10681f298b21E69CCe026B7aE50D34E7"; //正式ShanHaiJing  
let ShanHaiJingTokenAddress = "0xefb5df09bbebc936c82f8bca63169aa9c8ddce10"; //正式ShanHaiJing  
let FlowMinerTokenAddress = "0xd0785b6a59303e4f02b3fe171503bf3d412b75ca"; //正式FlowMiner
let CommunityIncentiveTokenAddress = "0xa4d1fd1153bedb5e5a1b666eaae429ebca32344c"; //正式CommunityIncentive 
let TokenStakingTokenAddress = "0xdac4c9bfca6785ca024f46121289fe98814bf3ef"; //TokenStaking正式
let LPStakingTokenAddress = "0xc63bad3fbbb7b86b5b70b1bb6e623ba75175e5a8"; //LPStaking正式
// let InvitationTokenAddress = "0xfe31031e9987be72a569be592b30ab4030b0a29f"; //Invitation正式
let USDTTokenAddress = "0x55d398326f99059ff775485246999027b3197955"; //usdt正式
let FlowToken="0x410f947a37cB62e0b37E0fc8e52e1d9973610270" //Flo正式代币地址
let LPTokenAddress = "0x54ec164be577734ee7e93664c524A6fC377aa56C"; //usdt正式
let web3 = new Web3(new Web3.providers.HttpProvider('https://bsc-dataseed2.ninicoin.io/'))//币安的节点
Contract.setProvider('https://bsc-dataseed2.ninicoin.io/')//币安的节点
let provider='';
let txHashs="";
export let datas = {
  NftAmount:"--",
  lastHarverstTime:'--', 
  historyIncome:"--", 
  historyReceived:"--",
  getFlowPrice:'--',
  GradeInformation:'--',
  undistributed:'--',
  SQClaimableEarnings:'--',
  SQReceivedEarnings:'--',
  NFTlaimableEarnings:'--',
  TheHandlingFeeToBeDeducted:'--',
  TheNumberOfLevelCards1:'--', 
  TheNumberOfLevelCards2:'--',  
  TheNumberOfLevelCards3:'--',  
  TheNumberOfLevelCards4:'--',  
  TheNumberOfLevelCards5:'--', 
  TheTimeBeforeCollection:'--',
  dialogVisible:false,
  FlowToken,
  TokenStakingTokenAddress,
  TokenTotalStaked:'--', 
  TokenDailyOutputAmount:'--', 
  TokenUserAmount:'--', 
  TokenPendingReward:'--', 
  TokenTotalClaimed:'--',
  LPTokenAddress,
  LPStakingTokenAddress,
  getUserOrderLengthData:0,
  getUserOrderDetailsByPageList:[],
  LPTokenAddressPrecision:0,
}
// 目标链是56
const TARGET_CHAIN_ID = process.env.VUE_APP_CHAIN_ID;

// 连接钱包并获取地址
export const connectWallet = async () => {
    try {
        await window.ethereum.request({ method: 'eth_requestAccounts' });
        provider = new ethers.providers.Web3Provider(window.ethereum);
        
        
        // 获取当前链ID
        const currentChainId = await provider.getNetwork().then(network => network.chainId);

        // 如果当前链ID不等于目标链ID，则切换链
        if (currentChainId != TARGET_CHAIN_ID) {
            await window.ethereum.request({
                method: 'wallet_switchEthereumChain',
                params: [{ chainId: `0x${parseInt(TARGET_CHAIN_ID).toString(16)}` }],
            });
        }

        const signer = provider.getSigner();
        const address = await signer.getAddress();
        console.log("连接钱包并获取地址",address);
        // 添加事件监听器
        // addEventListeners(provider);

        return address;
    } catch (error) {
        throw 'Please install wallet';
    }
};

// 签名消息
export const signMessage = async (message) => {
    const providers = new ethers.providers.Web3Provider(window.ethereum);
    const signer = providers.getSigner();
    const signature = await signer.signMessage(message);
    return signature;
};

// 添加事件监听器
export const addEventListeners = (vueInstance) => {
    
    // 监听账户变化
    window.ethereum.on('accountsChanged', async (accounts) => {
        if (accounts.length > 0) {
            const newAddress = accounts[0];
            console.log('监听账户变化123123');
            
            vueInstance.$store.dispatch('logout').then(() => {
                location.href = process.env.VUE_APP_CONTEXT_PATH + 'index';
            });
            vueInstance.$store.commit('setAddress', newAddress);
            // vueInstance.$store.dispatch('login');
            // 这里可以添加其他逻辑，比如更新UI等
        }
    });
    // 监听链变化
    window.ethereum.on('chainChanged', async (chainId) => {
        // 这里可以添加其他逻辑，比如重新连接钱包等
        // 例如，重新获取地址
        const newProvider = new ethers.providers.Web3Provider(window.ethereum);
        const newSigner = newProvider.getSigner();
        const newAddress = await newSigner.getAddress();
        console.log('newAddress',newAddress,chainId);
        
    });
};

// 更新钱包地址
export const JudgeTheConnectionWallet = async (vueInstance)=>{
        
    if (window.ethereum!==undefined){
      const myAccountAddr = vueInstance.$store.state.address;
      // 当连接的用户改变时，这里的 accounts 是只有一个元素的数组或者是空数组，数组的元素是字符串形式的地址。
      // console.log('更新钱包地址123456',window.ethereum.selectedAddress.toLowerCase(),myAccountAddr.toLowerCase(),window.ethereum.selectedAddress.toLowerCase() !== myAccountAddr.toLowerCase());
      if (window.ethereum.selectedAddress==null) {
        vueInstance.$store.commit('setAddress', myAccountAddr);
      }else{
        //切换钱包重新登录
        if (myAccountAddr&&window.ethereum.selectedAddress&&window.ethereum.selectedAddress.toLowerCase() !== myAccountAddr.toLowerCase()) {
          //需要更换
          console.log('需要更换123456');
          
          vueInstance.$store.dispatch('logout').then();
        }
        vueInstance.$store.commit('setAddress', window.ethereum.selectedAddress);
      }
    }
}

// 没有登录重新跳转到首页
export const locationHrefIndex = () => {
    const token = getToken();
    // console.log('没有登录重新跳转到首页',token);
    if (!token) {
        
        // Toast({
        //     message: this.$t('PleaseLogInFirst'),
        //     duration:2000,
        // });
        setTimeout(()=>{
            // Toast.clear();
            location.href = process.env.VUE_APP_CONTEXT_PATH;
        },1500)
        return true
    }else{
        return false
    }
}

// 转账
export const transferAccounts = async (to, value, tokenAddress,vueInstance) => {
    try {
        console.log('分别打印值',to, value, tokenAddress);
        let tokenContract =  new Contract(BUR, tokenAddress); // TokenABI 是代币合约的 ABI
        value=await CheckAccuracy(tokenAddress,value)
        const encodeABI =await tokenContract.methods.transfer(to,value).encodeABI()
        let txHash=await Authorization(encodeABI,tokenAddress,'',vueInstance)
        return Promise.resolve(txHash);
    } catch (err) {
        console.log('打印报错', err.message);
        vueInstance.$store.state.showOverlay=false
        datas.dialogVisible=false
        Vue.prototype.$toast(`${err.message}`);
        return Promise.reject(err);
    }
}  
// token质押
export const tokenStake = async (value,vueInstance) => {
    try {
        console.log('分别打印值',value, TokenStakingTokenAddress);
        let tokenContract =  new Contract(TokenStaking, TokenStakingTokenAddress); // TokenABI 是代币合约的 ABI
        value=await CheckAccuracy(FlowToken,value)
        const encodeABI =await tokenContract.methods.stake(value).encodeABI()
        console.log('分别打印值123',encodeABI,TokenStakingTokenAddress);
        let txHash=await Authorization(encodeABI,TokenStakingTokenAddress,'',vueInstance)
        return Promise.resolve(txHash);
    } catch (err) {
        console.log('打印报错', err.message);
        vueInstance.$store.state.showOverlay=false
        datas.dialogVisible=false
        Vue.prototype.$toast(`${err.message}`);
        return Promise.reject(err);
    }
}  
// 1. token领取奖励
//     function claim() external view returns (uint256 balance);

export const tokenClaim = async (vueInstance) => {
    try {
        console.log('分别打印值', TokenStakingTokenAddress);
        let tokenContract =  new Contract(TokenStaking, TokenStakingTokenAddress); // TokenABI 是代币合约的 ABI
        const encodeABI =await tokenContract.methods.claim().encodeABI()
        let txHash=await Authorization(encodeABI,TokenStakingTokenAddress,'',vueInstance)
        return Promise.resolve(txHash);
    } catch (err) {
        console.log('打印报错', err.message);
        vueInstance.$store.state.showOverlay=false
        datas.dialogVisible=false
        Vue.prototype.$toast(`${err.message}`);
        return Promise.reject(err);
    }
}  
// 1. token提现（解除质押）
//     function withdraw(amount) external view returns (uint256 balance);

export const tokenWithdraw = async (value,vueInstance) => {
    try {
      let tokenContract =  new Contract(TokenStaking, TokenStakingTokenAddress); // TokenABI 是代币合约的 ABI
      console.log('分别打印值', value,TokenStakingTokenAddress);
      value=await CheckAccuracy(FlowToken,value)
        const encodeABI =await tokenContract.methods.withdraw(value).encodeABI()
        let txHash=await Authorization(encodeABI,TokenStakingTokenAddress,'',vueInstance)
        return Promise.resolve(txHash);
    } catch (err) {
        console.log('打印报错', err.message);
        vueInstance.$store.state.showOverlay=false
        datas.dialogVisible=false
        Vue.prototype.$toast(`${err.message}`);
        return Promise.reject(err);
    }
}  
/**
 * 获取质押信息
 *   function getUserInfo( address address ) 
 *   address 玩家地址
 * - uint256 _totalStaked  总质押数量
  - uint256 _dailyOutputAmount  今日总产出
  - uint256 _userAmount  我的质押数量
  - uint256 _pendingReward  可领取
  - uint256 _totalClaimed   已经领取
 */ 
        
export const tokengetUserInfo = async (vueInstance) => {
    try { 
      let tokenContract =  new Contract(TokenStaking,TokenStakingTokenAddress); // TokenABI 是代币合约的 ABI
      console.log('查询的地址',vueInstance.$store.state.address);
      await tokenContract.methods.getUserInfo(vueInstance.$store.state.address).call().then(async (res)=>{
        console.log('等级信息',res);
        let token1precision=await NUMAY(FlowToken)
        datas.TokenTotalStaked=Number(res[0]/token1precision)
        datas.TokenDailyOutputAmount=Number(res[1]/token1precision)
        datas.TokenUserAmount=Number(res[2]/token1precision)
        datas.TokenPendingReward=Number(res[3]/token1precision)
        datas.TokenTotalClaimed=Number(res[4]/token1precision)
      })
      return Promise.resolve();
    } catch (err) {
        console.log('打印报错', err.message);
        Vue.prototype.$toast(`${err.message}`);
        return Promise.reject(err);
    }
}  
// LP质押 LPStaking LPStakingTokenAddress
export const LPStake = async (value,vueInstance) => {
    try {
        console.log('分别打印值',value, LPStakingTokenAddress);
        let tokenContract =  new Contract(LPStaking, LPStakingTokenAddress); // TokenABI 是代币合约的 ABI
        value=await CheckAccuracy(LPTokenAddress,value)
        const encodeABI =await tokenContract.methods.stake(value).encodeABI()
        let txHash=await Authorization(encodeABI,LPStakingTokenAddress,'',vueInstance)
        return Promise.resolve(txHash);
    } catch (err) {
        console.log('打印报错', err.message);
        vueInstance.$store.state.showOverlay=false
        datas.dialogVisible=false
        Vue.prototype.$toast(`${err.message}`);
        return Promise.reject(err);
    }
}  
// 1. LP领取奖励
//     function claim() external view returns (uint256 balance);

export const LPClaim = async (vueInstance) => {
    try {
        console.log('分别打印值', LPStakingTokenAddress);
        let tokenContract =  new Contract(LPStaking, LPStakingTokenAddress); // TokenABI 是代币合约的 ABI
        const encodeABI =await tokenContract.methods.claim().encodeABI()
        let txHash=await Authorization(encodeABI,LPStakingTokenAddress,'',vueInstance)
        return Promise.resolve(txHash);
    } catch (err) {
        console.log('打印报错', err.message);
        vueInstance.$store.state.showOverlay=false
        datas.dialogVisible=false
        Vue.prototype.$toast(`${err.message}`);
        return Promise.reject(err);
    }
}  
// 1. LP提现（解除质押）
//     function withdraw(amount) external view returns (uint256 balance);

export const LPWithdraw = async (value,vueInstance) => {
    try {
        console.log('分别打印值', value,LPStakingTokenAddress);
        let tokenContract =  new Contract(LPStaking, LPStakingTokenAddress); // TokenABI 是代币合约的 ABI
        value=await CheckAccuracy(LPStakingTokenAddress,value)
        const encodeABI =await tokenContract.methods.withdraw(value).encodeABI()
        let txHash=await Authorization(encodeABI,LPStakingTokenAddress,'',vueInstance)
        return Promise.resolve(txHash);
    } catch (err) {
        console.log('打印报错', err.message);
        vueInstance.$store.state.showOverlay=false
        datas.dialogVisible=false
        Vue.prototype.$toast(`${err.message}`);
        return Promise.reject(err);
    }
}  
/**
 * getUserOrderDetailsByPage 分页获取订单
 *   function getOrdersByPage( address address ) 
 *   address 玩家地址
 *   offset
 *   limit
 */ 
        
export const LPgetOrdersByPage = async (vueInstance,offset,limit) => {
    try { 
      let tokenContract =  new Contract(LPStaking,LPStakingTokenAddress); // TokenABI 是代币合约的 ABI
      console.log('查询的地址',vueInstance.$store.state.address,offset,limit);
      await tokenContract.methods.getUserOrderDetailsByPage(vueInstance.$store.state.address,offset,limit).call().then(async (res)=>{
        console.log('分页获取订单',res);
        datas.LPTokenAddressPrecision=await NUMAY(LPTokenAddress)
        datas.getUserOrderDetailsByPageList=res
      })
      return Promise.resolve();
    } catch (err) {
        console.log('打印报错', err.message);
        Vue.prototype.$toast(`${err.message}`);
        return Promise.reject(err);
    }
}  
/**
 * getUserOrderLength LP获取订单
 *   function getUserOrderLength( address address ) 
 *   address 玩家地址
 *   offset
 *   limit
 */ 
        
export const LPgetUserOrderLength = async (vueInstance) => {
    try { 
      let tokenContract =  new Contract(LPStaking,LPStakingTokenAddress); // TokenABI 是代币合约的 ABI
      console.log('查询的地址',vueInstance.$store.state.address);
      await tokenContract.methods.getUserOrderLength(vueInstance.$store.state.address).call().then(async (res)=>{
        console.log('LP获取订单',res);
        datas.getUserOrderLengthData=Number(res)
      })
      return Promise.resolve(datas.getUserOrderLengthData);
    } catch (err) {
        console.log('打印报错', err.message);
        Vue.prototype.$toast(`${err.message}`);
        return Promise.reject(err);
    }
}  
// 1. 查询玩家拥有的NFT数量
//     function balanceOf(address owner) external view returns (uint256 balance);

export const balanceOfFn = async (vueInstance) => {
    try {
      let tokenContract =  new Contract(ShanHaiJing, ShanHaiJingTokenAddress); // TokenABI 是代币合约的 ABI
      console.log('查询的地址',vueInstance.$store.state.address,tokenContract);
        // value=await CheckAccuracy(tokenAddress,value)
        await tokenContract.methods.balanceOf(vueInstance.$store.state.address).call().then(async (res)=>{
          console.log('返回值',res);
          datas.NftAmount=res
          // let numAy=await this.NUMAY(this.USDTAddresses)
          // this.USDT=(res/numAy).toFixed(8)
        })
        return Promise.resolve();
    } catch (err) {
        console.log('打印报错', err.message);
        Vue.prototype.$toast(`${err.message}`);
        return Promise.reject(err);
    }
}  

/**
 * 1. 用户收益信息详情
 * function getUserClaimState(address user) external view returns (uint256 lastHarverstTime, uint256 historyIncome, uint256 historyReceived);
 * user 社区玩家地址
 * 返回值, lastHarverstTime 用户上次领取时间 historyIncome 历史收入,没有扣除手续费之前的累计金额 historyReceived  历史接收的金额,  扣除手续费之后的累计金额
 */

export const getUserClaimStateFn = async (vueInstance) => {
    try {
      let tokenContract =  new Contract(FlowMiner,FlowMinerTokenAddress); // TokenABI 是代币合约的 ABI
      console.log('查询的地址',vueInstance.$store.state.address,tokenContract);
        await tokenContract.methods.getUserClaimState(vueInstance.$store.state.address).call().then(async (res)=>{
          let token1precision=await NUMAY(FlowToken)
          console.log('返回值',res,token1precision);
          datas.lastHarverstTime=res.lastHarverstTime 
          datas.historyIncome=res.historyIncome/token1precision
          datas.historyReceived=res.historyReceived/token1precision
        })
        return Promise.resolve();
    } catch (err) {
        console.log('打印报错', err.message);
        Vue.prototype.$toast(`${err.message}`);
        return Promise.reject(err);
    }
}  

/**
 * 未领取前的时间
 */

export const mintStartTimeFn = async () => {
    try {
      let tokenContract =  new Contract(FlowMiner,FlowMinerTokenAddress); // TokenABI 是代币合约的 ABI
      await tokenContract.methods.mintStartTime().call().then(async (res)=>{
        console.log('未领取前的时间',res);
        datas.TheTimeBeforeCollection=res
      })
      return Promise.resolve();
    } catch (err) {
        console.log('打印报错', err.message);
        Vue.prototype.$toast(`${err.message}`);
        return Promise.reject(err);
    }
}  

/**
 * Flow代币价格
 *   function getFlowPriceInUSDT() public view returns (uint256 price);
 */

export const getFlowPriceInUSDTFn = async () => {
    try {
      let tokenContract =  new Contract(FlowMiner,FlowMinerTokenAddress); // TokenABI 是代币合约的 ABI
      console.log('Flow代币价格返回值');
      await tokenContract.methods.getFlowPriceInUSDT().call().then(async (res)=>{
        console.log('Flow代币价格返回值',res);
        let token1precision=await NUMAY(USDTTokenAddress)
        let token2precision=await NUMAY(FlowToken)
        datas.getFlowPrice=(Number(res/token1precision/token2precision/token2precision)).toFixed(6) 
        // datas.getFlowPrice=res
      })
      return Promise.resolve();
    } catch (err) {
        console.log('打印报错', err.message);
        Vue.prototype.$toast(`${err.message}`);
        return Promise.reject(err);
    }
}  

/**
 * 查询用户的等级
 *   function userLevel( address user) external view returns (uint8)
 *   user 社区玩家地址
 * 返回值, 等级信息, 1-5有效的, 0代表无等级,或者用户不存在
 */ 
        
export const userLevelFn = async (vueInstance) => {
    try {
      let tokenContract =  new Contract(CommunityIncentive,CommunityIncentiveTokenAddress); // TokenABI 是代币合约的 ABI
      console.log('查询的地址',vueInstance.$store.state.address);
      await tokenContract.methods.userLevel(vueInstance.$store.state.address).call().then(async (res)=>{
        console.log('等级信息',res);
        datas.GradeInformation=res
      })
      return Promise.resolve();
    } catch (err) {
        console.log('打印报错', err.message);
        Vue.prototype.$toast(`${err.message}`);
        return Promise.reject(err);
    }
}  

/**
 * 查询用户每一个等级的卡牌
 *   function tokenOfOwnerByLevel( address owner ) external view returns (uint256, uint256, uint256, uint256, uint256)
 *   owner 玩家地址
 * 返回值,分别是5个等级卡片的数量
 */ 
        
export const tokenOfOwnerByLevelFn = async (vueInstance) => {
    try { 
      let tokenContract =  new Contract(ShanHaiJing,ShanHaiJingTokenAddress); // TokenABI 是代币合约的 ABI
      console.log('查询的地址',vueInstance.$store.state.address);
      await tokenContract.methods.tokenOfOwnerByLevel(vueInstance.$store.state.address).call().then(async (res)=>{
        console.log('等级信息',res);
        datas.TheNumberOfLevelCards1=res[0]
        datas.TheNumberOfLevelCards2=res[1]
        datas.TheNumberOfLevelCards3=res[2]
        datas.TheNumberOfLevelCards4=res[3]
        datas.TheNumberOfLevelCards5=res[4]
      })
      return Promise.resolve();
    } catch (err) {
        console.log('打印报错', err.message);
        Vue.prototype.$toast(`${err.message}`);
        return Promise.reject(err);
    }
}  

/**
 * 查询社区未分配手续费总额
 * function getUnDistributeRewardAmount() external view returns (uint256);
 *  返回值, 社区未分配手续费总额
 */ 
        
export const getUnDistributeRewardAmountFn = async () => {
    try {
      let tokenContract =  new Contract(CommunityIncentive,CommunityIncentiveTokenAddress); // TokenABI 是代币合约的 ABI
      console.log('查询社区未分配手续费总额');
      await tokenContract.methods.getUnDistributeRewardAmount().call().then(async (res)=>{
        console.log('查询社区未分配手续费总额',res);
        let token1precision=await NUMAY(FlowToken)
        datas.undistributed=(Number(res/token1precision)).toFixed(2) 
      })
      return Promise.resolve();
    } catch (err) {
        console.log('打印报错', err.message);
        Vue.prototype.$toast(`${err.message}`);
        return Promise.reject(err);
    }
}  

/**
 * 社区查询用户可领取收益信息 
 * function userEarned( address user) external view returns (uint256)
 *  user 社区玩家地址
 * 返回值, 社区用户可领取收益
 */ 
export const userEarnedFn = async (vueInstance) => {
    try {
      let tokenContract =  new Contract(CommunityIncentive,CommunityIncentiveTokenAddress); // TokenABI 是代币合约的 ABI
      console.log('查询的地址',vueInstance.$store.state.address);
      await tokenContract.methods.userEarned(vueInstance.$store.state.address).call().then(async (res)=>{
        console.log('查询用户可领取收益信息',res);
        let token1precision=await NUMAY(FlowToken)
        datas.SQClaimableEarnings=(Number(res/token1precision)).toFixed(2) 
      })
      return Promise.resolve();
    } catch (err) {
        console.log('打印报错', err.message);
        Vue.prototype.$toast(`${err.message}`);
        return Promise.reject(err);
    }
}  

/**
 * nft查询用户可领取收益信息 
 *  function calculateRewards(address user) public view returns (uint256);      
 *  user 玩家地址
 * 返回值, 能领取的金额,要扣除的手续费
 */ 
export const calculateRewardsFn = async (vueInstance) => {
    try {  
      let tokenContract =  new Contract(FlowMiner,FlowMinerTokenAddress); // TokenABI 是代币合约的 ABI
      console.log('查询的地址',vueInstance.$store.state.address);
      await tokenContract.methods.calculateRewards(vueInstance.$store.state.address).call().then(async (res)=>{
        console.log('查询用户可领取收益信息',res);
        let token1precision=await NUMAY(FlowToken)
        datas.NFTlaimableEarnings=(res[0]/token1precision)
        datas.TheHandlingFeeToBeDeducted=(res[1]/token1precision)
      })
      return Promise.resolve();
    } catch (err) {
        console.log('打印报错', err.message);
        Vue.prototype.$toast(`${err.message}`);
        return Promise.reject(err);
    }
}  


/**
 * 查询用户已领取收益信息  
 * function userClaimed( address user) external view returns (uint256)
 *   user 社区玩家地址
 * 返回值, 社区用户已领取收益
 */ 
export const userClaimedFn = async (vueInstance) => {
    try {
      let tokenContract =  new Contract(CommunityIncentive,CommunityIncentiveTokenAddress); // TokenABI 是代币合约的 ABI
      console.log('查询的地址',vueInstance.$store.state.address);
      await tokenContract.methods.userClaimed(vueInstance.$store.state.address).call().then(async (res)=>{
        console.log('查询用户已领取收益信息',res);
        let token1precision=await NUMAY(FlowToken)
        datas.SQReceivedEarnings=(Number(res/token1precision)).toFixed(2) 
      })
      return Promise.resolve();
    } catch (err) {
        console.log('打印报错', err.message);
        Vue.prototype.$toast(`${err.message}`);
        return Promise.reject(err);
    }
}  

/**
 * 查询等级用户数量  
 *  function getLevelUserCount(uint8 level) external view returns (uint256);
 *   level 等级,从1-5
 * 返回值, 用户数量
 */ 
export const getLevelUserCountFn = async (num) => {
    try {
      let numberOfUsers=0;
      let tokenContract =  new Contract(CommunityIncentive,CommunityIncentiveTokenAddress); // TokenABI 是代币合约的 ABI
      console.log('查询等级用户数量',num);
      numberOfUsers=await tokenContract.methods.getLevelUserCount(num).call()
      console.log('查询等级用户数量',numberOfUsers);
      return Promise.resolve(numberOfUsers);
    } catch (err) {
        console.log('打印报错', err.message);
        Vue.prototype.$toast(`${err.message}`);
        return Promise.reject(err);
    }
}  

/**
 * 社区玩家领取收益  
 * function claim() external;
 * 玩家自己触发
 */ 
export const claimFn = async (vueInstance) => {
    try {
      let tokenContract =  new Contract(CommunityIncentive,CommunityIncentiveTokenAddress); // TokenABI 是代币合约的 ABI
      console.log('社区玩家领取收益');
      const encodeABI =await tokenContract.methods.claim().encodeABI()
      let txHash=await Authorization(encodeABI,CommunityIncentiveTokenAddress,'',vueInstance)
      return Promise.resolve(txHash);
    } catch (err) {
        console.log('打印报错', err.message);
        Vue.prototype.$toast(`${err.message}`);
        return Promise.reject(err);
    }
}  

/**
 * nft领取NFT持有奖励  
 * function claim() external;
 * 玩家自己触发
 */ 
export const harvestFn = async (vueInstance) => {
    try { 
      let tokenContract =  new Contract(FlowMiner,FlowMinerTokenAddress); // TokenABI 是代币合约的 ABI
      console.log('社区玩家领取收益');
      const encodeABI =await tokenContract.methods.harvest().encodeABI()
      let txHash=await Authorization(encodeABI,FlowMinerTokenAddress,'',vueInstance)
      return Promise.resolve(txHash);
    } catch (err) {
        console.log('打印报错', err.message);
        Vue.prototype.$toast(`${err.message}`);
        datas.dialogVisible=false
        return Promise.reject(err);
    }
}  


/**
       * 处理精度转16进制
       * @param {string} Adress 代币地址
       * @param {number} quotaNum 代币数量 
       * @returns 
       */
const CheckAccuracy = async (Adress,quotaNum) => {
    try{
        let numAy=await NUMAY(Adress)
        console.log('参数',Adress,quotaNum,numAy);
        quotaNum = Vue.prototype.$BigNumber(quotaNum).multipliedBy(numAy).toString(16)
        console.log(quotaNum);
        quotaNum = '0x' + quotaNum
        console.log('这里',quotaNum);
        return Promise.resolve(quotaNum)
    }catch(err){
        Vue.prototype.$toast({
            message: `处理精度转16进制失败`,
            duration:2000,
        });
        return Promise.reject(err)
    }
}

/**
       * 查询对应代币的精度
       * @param {*} Adress 对应代币地址
       * @returns 
       */
const NUMAY = async (Adress) => {
    try{
        console.log(Adress);
        let contract=await new Contract(ERC20,Adress)
        console.log(contract);
        let numAy=await contract.methods.decimals().call()
        console.log(Adress,numAy);
        numAy = Math.pow(10, numAy)
        console.log(numAy);
        return Promise.resolve(numAy)
    }catch(err){
        // Toast({
        //     message: `查询对应代币的精度失败`,
        //     duration:2000,
        // });
        return Promise.reject(err)
    }
}

// 授权
const Authorization = async (encodeABI,add,quotaNum,vueInstance)=>{
    try {
        let gasPrice;
        gasPrice = await getGasPrice()
        console.log(gasPrice);
        const gas = await web3EstimateGas(encodeABI, add, gasPrice,quotaNum,vueInstance)
        console.log(gas);
        let txHash;
        txHash = await metaMaskSendTransaction(encodeABI, add, gasPrice, gas,quotaNum,vueInstance)
        return txHash
    } catch (err) {
      vueInstance.$store.state.showOverlay=false
      datas.dialogVisible=false
      return Promise.reject(err)
    }
}
const web3EstimateGas = async  (data, to, gasPrice,value,vueInstance) => {
    try {
      const myAccountAddr = vueInstance.$store.state.address;
      console.log('在887',data, to,myAccountAddr);
      let gas 
      value?value:value='0x0'
      console.log('查看value',value);
      if (value=='0x0'||value=='0') {
        gas = await web3.eth.estimateGas({
          data,
          from: myAccountAddr,
          to,
        })
      }else{
        console.log('进入了链换其他的币');
        gas = await web3.eth.estimateGas({
          data,
          from: myAccountAddr,
          to,
          gasPrice,
          value,
        })
      }
      console.log('在893',gas,1.2);
      gas = parseInt(gas * 1.2).toString()
      console.log(gas);
      return Promise.resolve(gas)
    } catch (err) {
      Vue.prototype.$toast(String(err))
      vueInstance.$store.state.showOverlay=false
      datas.dialogVisible=false
      return Promise.reject(err)
    }
}

//发起交易
const metaMaskSendTransaction = async (encodeABI, to, gasPrice, gas,value,vueInstance) => {
    try {
      let transactionParameters ;
      const myAccountAddr = vueInstance.$store.state.address;
      let nonce = await web3.eth.getTransactionCount(myAccountAddr, 'pending')
      console.log(nonce);
      nonce = '0x' + Vue.prototype.$BigNumber(nonce).toString(16)
      console.log("获取gas价格22",gasPrice);
      console.log('/发起交易',gasPrice,gas);
      value?value:value='0x0'
      if (value=='0x0') {
        transactionParameters = {
          nonce,
          data: encodeABI,
          from: myAccountAddr,
          to,
          gasPrice,
          gas,
        }
      }else{
        transactionParameters = {
          nonce,
          data: encodeABI,
          from: myAccountAddr,
          to,
          gasPrice,
          gas,
          value:value,
        }
      }
      console.log('有没有到这里',transactionParameters);
      const txHash = await window.ethereum.request({
        method: 'eth_sendTransaction',
        params: [transactionParameters]
      })
      txHashs=txHash
      console.log('发起交易hash',txHash);
      return await Promise.resolve(txHash)
    } catch (err) {
      console.log('报错',err.message);
      vueInstance.$store.state.showOverlay=false
      datas.dialogVisible=false
      Vue.prototype.$toast(`${err.message}`)
      return Promise.reject(err)
    }
}

const getGasPrice = async () => { // 获取gas价格
    try {
        let gasPrice = await web3.eth.getGasPrice()
        console.log("获取gas价格1",gasPrice);
        gasPrice = '0x' + Vue.prototype.$BigNumber(gasPrice).toString(16)
        console.log("获取gas价格2",gasPrice);
        return Promise.resolve(gasPrice)
    } catch (err) {
        Vue.prototype.$toast(Vue.prototype.$myI18n.t('GasPriceacquisitionfailed'))
        return Promise.reject(err)
    }
}
//查看授权代币是否足够
export const isTokenAddress = async (ERCContract,addresses, contAdd,value,vueInstance) => { // 查看授权
  try {
    const myAccountAddr = vueInstance.$store.state.address;
    console.log('过来了3',ERCContract);
    console.log('过来了3',addresses);
    console.log('过来了3', contAdd);
    console.log('过来了3',value);
    console.log('过来了3',vueInstance.$store.state.address);
    let num = await ERCContract.methods.allowance(myAccountAddr, contAdd).call()
    let numAy = await ERCContract.methods.decimals().call()
    numAy = Math.pow(10, Number(numAy))
    // num = this.$BigNumber(num).dividedBy(numAy).toString()
    num = Vue.prototype.$BigNumber(num).dividedBy(numAy).toString()
    console.log(num);
    // 查看下缓存有无交易哈希，有则清除
    let tokenAuth = localStorage.getItem('tokenAuth')
    let isAuth = false
    console.log(num);
    if (Number(num) >= Number(value)) { // 数量大于0，已授权
      isAuth = true
      if (tokenAuth) {
        tokenAuth = JSON.parse(tokenAuth)
        tokenAuth.forEach((item, index) => {
          if (item.myAccountAddr === myAccountAddr && addresses === item.tokenAdd && contAdd === item.contAdd) { // 获取缓存里的当前交易哈希
            tokenAuth.splice(index, 1)
            tokenAuth = JSON.stringify(tokenAuth)
            localStorage.setItem('tokenAuth', tokenAuth)
          }
        })
      }
    }
    return Promise.resolve(isAuth)
  } catch (err) {
    return Promise.reject(err)
  }
}
export const approve = async (ERCContract,addresses,contAdd, quotaNum,vueInstance) => { // 代币授权
  try {
    let numAy = await ERCContract.methods.decimals().call()
    numAy = Math.pow(10, numAy)
    quotaNum = Vue.prototype.$BigNumber(quotaNum).multipliedBy(numAy).toString(16)
    quotaNum = '0x' + quotaNum
    console.log(ERCContract,addresses,contAdd, quotaNum);
    const encodeABI = ERCContract.methods.approve(contAdd, quotaNum).encodeABI()
    // const gasPrice = await this.getFeeHistory()
    let gasPrice;
    gasPrice = await getGasPrice()
    const value = '0'
    const gas = await web3EstimateGas(encodeABI, addresses, gasPrice, value,vueInstance)
    let txHash
    txHash = await metaMaskSendTransaction(encodeABI, addresses, gasPrice, gas, value,vueInstance)
    // Vue.prototype.$toast('等待链上操作')
    await saveAllowance(txHash, addresses, contAdd,vueInstance)
    return await Promise.resolve()
  } catch (err) {
    return Promise.reject(err)
  }
}
// 操作代币授权缓存
export const saveAllowance = async (txhash, addresses, contAdd,vueInstance) => {
  let tokenAuth = localStorage.getItem('tokenAuth')
  const myAccountAddr = vueInstance.$store.state.address;
  const allowanceItem = {
    walletAddress: myAccountAddr, // 连接的钱包地址
    txhash, // 交易哈希
    addresses,
    contAdd
  }
  if (tokenAuth) {
    tokenAuth = JSON.parse(tokenAuth)
  } else {
    tokenAuth = []
  }
  tokenAuth.push(allowanceItem)
  tokenAuth = JSON.stringify(tokenAuth)
  localStorage.setItem('tokenAuth', tokenAuth)
}
//查看某代币余额
export const ViewATokenBalance = async (ass,vueInstance) => {
  try{
    let someUSDT;
    const myAccountAddr = vueInstance.$store.state.address;
    console.log('查看某代币余额',ass,myAccountAddr);
    let abiercContractSR=await new Contract(abierc,ass)
    console.log('123456');
    
    await abiercContractSR.methods.balanceOf(myAccountAddr).call().then(async (res)=>{
      console.log('进来了，代币返回值',res);
      
      let numAy=await NUMAY(ass)
      someUSDT=res/numAy
      console.log('查看某代币余额',someUSDT,ass,(Number(someUSDT)).toFixed(6));
    })
    return Promise.resolve(someUSDT)
  }catch(err){
    return Promise.reject(err)
  }
}

//监听交易是否完成
export const ztai = async () => {
  if (txHashs) {
    provider = new ethers.providers.Web3Provider(window.ethereum);
    let blockHash=await provider.getTransaction(txHashs).then((blockNumber) => {
      try {
        console.log('blockNumber.blockHash',blockNumber.blockHash);
        return blockNumber.blockHash
      } catch (error) {
        console.log('报错',error);
        
      }
     
    });
    console.log('过来了');
    
    return blockHash
  }
}

export const setMyVariable = (value) => {
  txHashs = value;
};